// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nectary-theme-base {\n  --sinch-flag-src-url: \"https://flagcdn.com/%s.svg\";\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@nectary/theme-base/comp/flag.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;AACpD","sourcesContent":[".nectary-theme-base {\n  --sinch-flag-src-url: \"https://flagcdn.com/%s.svg\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
